<template>
  <div class="create-edit-policy_container">
    <div v-if="mode === 'create'">
      <organism-policy
        :mode="mode"
        :hasUpdatePermission="hasUpdatePermission"
        @clickBack="clickBack"
        @clickCreate="clickCreate"
      ></organism-policy>
    </div>

    <div v-else>
      <organism-policy
        v-if="!isLoading"
        :mode="mode"
        :equipmentData="equipmentData"
        :resourceData="resourceData"
        :hasUpdatePermission="hasUpdatePermission"
        @clickBack="clickBack"
        @clickSave="clickSave"
      ></organism-policy>
    </div>
  </div>
</template>

<script>
import OrganismPolicy from "@/components/organisms/OrganismPolicy.vue"
import {
  addPolicyManagement,
  getPolicyManagementById,
  getPolicyManagementUnits,
  updatePolicyManagementById,
} from "@/api/api-module"
import { PermissionUser } from "@/constants/permission-user"
import mixins from "@/mixins"
import mixinsUser from "@/mixins/mixinsUser"
export default {
  name: "CreateEditPolicy",
  components: { OrganismPolicy },
  mixins: [mixins, mixinsUser],
  data() {
    return {
      mode: "",
      unitList: [],
      equipmentData: {
        id: "",
        name: "",
        description: "",
      },
      resourceData: [
        {
          resource: "CPU",
          warning: "24",
          critical: "24",
          unit: {
            id: "",
            name: "",
          },
          isEnabled: true,
        },
      ],

      resourceDataBeforePush: [],
    }
  },
  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.SMS.POLICY_WRITE)
    },
    isLoading() {
      return this.equipmentData.id === ""
    },
  },
  created() {
    this.mode =
      this.$route.path === "/server-management/policy/create"
        ? "create"
        : "edit"
  },
  async mounted() {
    if (this.mode === "edit") {
      await this.getPolicyManagementUnitsList()
      await this.getPolicyById()
    }
  },
  methods: {
    clickBack() {
      this.$router.push("/server-management/policy")
    },

    async clickCreate(request) {
      this.showLoading(true)
      const response = await addPolicyManagement(request)
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("Policy added successfully")
        this.clickBack()
      } else {
        this.toastError("Policy added failed")
      }
    },

    async clickSave(request) {
      this.showLoading(true)
      const response = await updatePolicyManagementById(
        this.$route.params.id,
        request
      )
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("Policy updated successfully")
        this.clickBack()
      } else {
        this.toastError("Policy updated failed")
      }
    },

    // get policy unit
    async getPolicyManagementUnitsList() {
      this.showLoading(true)
      await getPolicyManagementUnits()
        .then((response) => {
          this.unitList = []
          response.forEach((unit) => {
            this.unitList.push({
              type: unit.policyResourceTypeName,
              id: unit.policyUnitId,
              name: unit.policyUnitName,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    async getPolicyById() {
      this.showLoading(true)
      this.equipmentData = {
        id: "",
        name: "",
        description: "",
      }
      this.resourceData = []
      await getPolicyManagementById(this.$route.params.id)
        .then((response) => {
          this.equipmentData = {
            id: response.policy.policyId,
            name: response.policy.policyName,
            description: response.policy.policyDescription,
          }
          response.policyValue.forEach((policy) => {
            const unitName = this.unitList.find(
              (unit) => unit.id === policy.policyResourceUnitId
            ).name
            this.resourceData.push({
              resource: policy.policyResourceTypeName,
              warning: policy.policyResourceWarningThreshold,
              critical: policy.policyResourceCriticalThreshold,
              unit: {
                id: policy.policyResourceUnitId,
                name: unitName,
              },
              isEnabled: policy.policyResourceEnable,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped>
.create-edit-policy_container {
  padding-bottom: 60px;
}
</style>
